import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import './index.scss';
import App from './reactComponents/App/App.js';
import * as serviceWorker from './serviceWorker';

import thunkMiddleware from 'redux-thunk'
import {createLogger} from 'redux-logger'
import rootReducer from './rootReducer.js'
import { applyMiddleware, createStore } from 'redux';
import {Provider} from 'react-redux'

let middleware = []
if (process.env.NODE_ENV === 'production') {
  middleware = [...middleware, thunkMiddleware]
} else {
  middleware = [...middleware, thunkMiddleware, createLogger()]
}

const store = createStore(
  rootReducer,
  applyMiddleware(...middleware)
)

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback="loading">
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
